/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Product_Giveaways_WriteInputs */



/**
* | output |
* | --- |
* | "Create, edit, end and delete giveaways and their templates" |
*
* @param {Perm_Product_Giveaways_WriteInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_product_giveaways_write = /** @type {((inputs?: Perm_Product_Giveaways_WriteInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Product_Giveaways_WriteInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создавать, изменять, завершать и удалять розыгрыши и их шаблоны")
	return /** @type {LocalizedString} */ ("Create, edit, end and delete giveaways and their templates")
});